import { render, staticRenderFns } from "./FilterShippingForm.vue?vue&type=template&id=67689728&scoped=true"
import script from "./FilterShippingForm.vue?vue&type=script&lang=js"
export * from "./FilterShippingForm.vue?vue&type=script&lang=js"
import style0 from "./FilterShippingForm.vue?vue&type=style&index=0&id=67689728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67689728",
  null
  
)

export default component.exports